module.exports = (parcelRequire.load("5igcT")).then(() => parcelRequire('j3gV0'));